import React from "react"

const SectionThoughtLeadership = () => (
  <section className="tl-sec">
    <div className="wrap">
      <h2>Additional Examples of Our Thought Leadership</h2>
      <div className="pubs2">
        <div className="pub2">
          <span className="jrnl">Harvard Business Review</span>
          <b>Getting Bundled Payments Right in Health Care</b>
          <span className="by">
            Derek A. Haas, Robert S. Kaplan, and colleagues
          </span>
          <div className="pub-links">
            <a
              href="https://hbr.org/2015/10/getting-bundled-payments-right-in-health-care"
              target="_blank"
              rel="noopener"
            >
              Read article{" "}
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M6 3h7v7M13 3L5 11"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="pub2">
          <span className="jrnl">Harvard Business Review</span>
          <b>
            Physicians Can Help Cut Costs. They Just Need the Right Incentives.
          </b>
          <span className="by">Susanna Gallani and Derek A. Haas</span>
          <div className="pub-links">
            <a
              href="https://hbr.org/2024/10/physicians-can-help-cut-costs-they-just-need-the-right-incentives"
              target="_blank"
              rel="noopener"
            >
              Read article{" "}
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M6 3h7v7M13 3L5 11"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="pub2 jama">
          <span className="jrnl">JAMA</span>
          <b>
            Economic and Clinical Outcomes Under CMS Mandatory Bundled Payments
            for Joint Replacements
          </b>
          <span className="by">Haas, Zhang, Kaplan, and Song</span>
          <div className="pub-links">
            <a
              href="https://pubmed.ncbi.nlm.nih.gov/31157819/"
              target="_blank"
              rel="noopener"
            >
              Read article{" "}
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <path
                  d="M6 3h7v7M13 3L5 11"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <p className="pdfnote">
        Would you like a PDF copy of an article?{" "}
        <a href="mailto:derek@avantgardehealth.com?subject=Article%20PDF%20request">
          Email Derek Haas
        </a>
        .
      </p>
    </div>
  </section>
)

export default SectionThoughtLeadership
